"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const formik_1 = require("formik");
const CustomCheckBox = (_a) => {
    var { name, value, label, disabled, ariaLabelledBy } = _a, rest = __rest(_a, ["name", "value", "label", "disabled", "ariaLabelledBy"]);
    const id = `${name}-${value}`;
    const labelId = `${id}-label`;
    return ((0, jsx_runtime_1.jsxs)("div", { className: `custom-checkbox-inline ${disabled ? 'disabled' : ''}`, children: [(0, jsx_runtime_1.jsx)(formik_1.Field, Object.assign({ type: "checkbox", id: id, name: name, value: value, disabled: disabled, className: "custom-checkbox-input", "aria-disabled": disabled, "aria-labelledby": `${ariaLabelledBy} ${labelId}` }, rest)), (0, jsx_runtime_1.jsx)("label", { id: labelId, htmlFor: id, className: `custom-checkbox-inline-label ${disabled ? 'disabled' : ''}`, children: label })] }));
};
exports.default = CustomCheckBox;
